import { Paginator, TableComponent, TableLoader } from 'components';
import { usePagination } from 'hooks';
import { FC } from 'react';
import { usePayoutRequests, useSupplierWallets } from '../hooks/use-wallet';
import moment from 'moment';
import { useAppSearch, useCurrentUser } from '_graphql/cache/auth';
import { CountryCode } from '_graphql/__generated__/globalTypes';
import { GetWalletPayouts_getWalletPayouts } from '_graphql/queries/__generated__/GetWalletPayouts';

type Props = {};

const PayoutsTab: FC<Props> = (props) => {
  const currentUser = useCurrentUser();
  const searchParams = useAppSearch();
  const { offset, limit, setPage } = usePagination();
  const { wallets } = useSupplierWallets({
    userId: currentUser?.id,
  });
  const walletId =
    wallets.find(
      (w) => w?.currency?.code && !w.currency.code.startsWith('p')
    )?.id ?? wallets[0]?.id;
  const { payouts, loading, refetch, count } = usePayoutRequests({
    variables: {
      input: {
        filter: {
          country: {
            eq: CountryCode.GH,
          },
          wallet_id: {
            eq: walletId,
          },
          transaction_id: searchParams?.search
            ? {
                eq: `${searchParams.search}`,
              }
            : undefined,
        },
      },
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });
  return (
    <TableComponent
      title={'Payout Requests'}
      columns={[
        {
          accessor: 'transaction_id',
          name: 'transaction id',
          render: (value: GetWalletPayouts_getWalletPayouts) =>
            value.transaction?.id,
        },
        {
          accessor: 'provider',
          name: 'Provider',
        },
        {
          accessor: 'account_number',
          name: 'Account Number',
        },
        {
          accessor: 'account_name',
          name: 'Account name',
        },
        {
          accessor: 'amount',
          name: 'Amount',
        },
        {
          accessor: 'status',
          name: 'Status',
        },
        {
          accessor: 'updated_at',
          name: 'Last Updated',
          render: (value: GetWalletPayouts_getWalletPayouts) =>
            moment(value.transaction?.updated_at).format(
              'Do, MMM YYYY hh:mm A'
            ),
        },
      ]}
      hasSearch
      data={payouts}
      loading={loading}
      refetch={refetch}
      renderLoader={() => <TableLoader items={[1, 1, 1, 1, 1, 1, 1]} />}
      emptyDescription="No Payout Requests found"
      pagination={() => (
        <Paginator
          offset={offset}
          limit={limit}
          totalItems={count}
          currentSize={payouts.length}
          setOffset={setPage}
        />
      )}
    />
  );
};

export default PayoutsTab;
